/**
 * トップページに関する処理
 */

import SplideDefault from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default class Index {
  constructor() {
    this.parent = document.querySelector('#js-page-index');
    if (!this.parent) return;
    this.fv = document.querySelector('#js-index-fv');
    this.init();
  }

  splide() {
    const target = document.querySelector('#js-index-partner-splide');
    const options = {
      type: 'loop',
      // fixedWidth: '180px',
      autoWidth: true,
      gap: '80px',
      arrows: false,
      pagination: false,
      drag: false,
      drag: 'free',
      // flickPower: 300,
      autoScroll: {
        speed: 0.8,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        768: {
          gap: '32px',
        }
      },
    }
    const mySplide = new SplideDefault(target, options);
    mySplide.mount({ AutoScroll }); //拡張機能をセットする
  }

  /**
   * 画像読み込みが完了したらアニメーション用の属性を付ける
   */
  loadedSetAttr() {
    window.addEventListener('load', () => {
      this.fv.setAttribute('data-loaded', '');
    });
  }

  init() {
    this.splide();
    this.loadedSetAttr();
  }
}
